import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { ICustomDatePickerProps } from 'store/ducks/Global/types';
import * as Styled from './CustomDatePicker.styled';

export const CustomDatePicker: React.FC<ICustomDatePickerProps> = ({
  defaultValue,
  ...rest
}) => {
  const dateFormat = 'YYYY-MM-DD';
  const dateIsValid = dayjs(defaultValue, dateFormat).isValid();

  return (
    <>
      <Styled.GlobalCalendarStyle />
      <Styled.DatePickerWrapper>
        {dateIsValid ? (
          <DatePicker
            defaultValue={dayjs(defaultValue, dateFormat)}
            {...rest}
          />
        ) : (
          <DatePicker placeholder='None' {...rest} />
        )}
      </Styled.DatePickerWrapper>
    </>
  );
};
